import { ErrorAlertProvider } from 'lib/ErrorAlert';
import { RouterProvider } from 'react-router';
import { ErrorSnackbar } from '../components/common/ErrorSnackbar';
import { RefreshProvider } from '../context/RefreshContext';
import { router } from '../routes/Router';
import { AuthProvider } from './AuthProvider';
import { MuiThemeProvider } from './MuiThemeProvider';
import { SWRConfigProvider } from './SWRConfigProvider';

export const AppProviders = () => {
  return (
    <MuiThemeProvider>
      <ErrorAlertProvider>
        <SWRConfigProvider>
          <AuthProvider>
            <RefreshProvider>
              <RouterProvider router={router} />
            </RefreshProvider>
            <ErrorSnackbar />
          </AuthProvider>
        </SWRConfigProvider>
      </ErrorAlertProvider>
    </MuiThemeProvider>
  );
};
